import { create } from 'zustand';
import { ProductConditionType, ProductLine } from 'types';

interface ProductState {
  currentProduct: ProductLine | null;
  setCurrentProduct: (product: ProductLine | null) => void;
  isProductNew: boolean | null;
  setProductNew: (isNew: boolean | null) => void;
  productCondition: ProductConditionType | null;
  setProductCondition: (condition: ProductConditionType | null) => void;
  reset: () => void;
}

export const useProductStore = create<ProductState>((set) => ({
  currentProduct: null,
  setCurrentProduct: (product: ProductLine | null) => set({ currentProduct: product }),
  isProductNew: null,
  productCondition: null,
  setProductCondition: (condition: ProductConditionType | null) =>
    set({ productCondition: condition }),
  setProductNew: (isNew: boolean | null) => set({ isProductNew: isNew }),
  reset: () => set({ currentProduct: null, isProductNew: null, productCondition: null }),
}));
